module.exports = __webpack_public_path__ + "static/media/between_fingers.2b613efb.svg";